import { $host } from './index';
import { AppDispatch } from '@store';
import { isSpinAC, notificationModalAC, otpLifeTimeAC } from '@store/reducers/app';
import { deadlineAC, ordersAC, transactionsHistoryAC } from '@store/reducers/transactions';
import openNotification from '@utils/openNotification';
import { getBulkTransactionInfoApi } from './bulkTransaction';
import { getSalaryInfoApi } from './salary';

const END_POINT = '/client';

const getTransactionListApi = (page: number, params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/list?page=${page}`, params);
    dispatch(transactionsHistoryAC(data));
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const transactionVerifyApi = (params: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    await $host.post(`${END_POINT}/transaction/verify`, params);

    openNotification('success', {
      description: 'Транзакция успешно проведена',
    });

    callback();
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const electricTransactionVerifyApi = (params: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    await $host.post(`${END_POINT}/utils/payment/verify`, params);

    openNotification('success', {
      description: 'Транзакция успешно проведена',
    });

    callback();
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const transactionVerifyResendCodeApi = (params: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/verify/resend_code`, params);
    if (data) {
      dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      dispatch(otpLifeTimeAC(Date.now() + 1000 * data.code_lifetime));
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getAccountOrdersApi = (params: object, page: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/statement/orders?page=${page}`, params);
    dispatch(ordersAC(data));
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const cleanOrdersApi = (query: object, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/statement/order/delete`, query);
    if (data) {
      callback();
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const dowloadAccountStatementApi = (params: object, format: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const response = await $host.post(`${END_POINT}/transaction/statement/order/download`, params, {
      responseType: 'arraybuffer',
    });
    const dispositionHeader = response.headers['content-disposition'];
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(dispositionHeader);
    let filename = `statement.${format}`;
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    const url = window.URL.createObjectURL(new Blob([response.data], { type: `application/${format}` }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.click();
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const dowloadAccountStatementToPrintApi = (params: object, format: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/statement/order/download`, params, {
      responseType: 'arraybuffer',
    });
    const blob = new Blob([data], { type: `application/${format}` });

    const url = URL.createObjectURL(blob);

    const printWindow = window.open(url, '_blank');

    printWindow?.addEventListener('load', () => {
      printWindow?.print();
    });
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const orderStatementApi = (params: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/statement/order`, params);
    if (data) {
      openNotification('success', {
        description: 'Выписка заказана!',
      });
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const electricTransactionApproveApi = (params: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    await $host.post(`${END_POINT}/utils/payment/approve`, params);
    return true;
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error.response?.data?.detail,
        type: 'error',
      })
    );
    return false;
  } finally {
    dispatch(isSpinAC(false));
  }
};

const refreshApproveSource = (dispatch: AppDispatch, trnType: string, fileId: string) => {
  if (trnType === 'BULK') {
    dispatch(getBulkTransactionInfoApi({ file_id: fileId }, 1));
  } else if (trnType === 'SALARY') {
    dispatch(getSalaryInfoApi({ file_id: fileId }, 1));
  }
};

const transactionApproveApi = (params: any, callback?: any) => async (dispatch: AppDispatch) => {
  const { params: transactionParams, fileId } = params;
  try {
    dispatch(isSpinAC(true));
    await $host.post(`${END_POINT}/transaction/approve`, transactionParams);
    refreshApproveSource(dispatch, transactionParams.trn_type, fileId);
    if (callback) {
      callback();
    }
    return true;
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error.response?.data?.detail,
        type: 'error',
      })
    );
    refreshApproveSource(dispatch, transactionParams.trn_type, fileId);
    return false;
  } finally {
    dispatch(isSpinAC(false));
  }
};

interface MassiveApproveParams {
  trans_id: string[];
  action: string;
}

const transactionMassiveApproveApi = (params: MassiveApproveParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    await $host.post(`${END_POINT}/transaction/approve/massive`, params);
    return true;
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
    return false;
  } finally {
    dispatch(isSpinAC(false));
  }
};

const proceedExchangeApi = (params: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/fx/proceed`, params);
    return Boolean(data);
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
    return false;
  } finally {
    dispatch(isSpinAC(false));
  }
};

const cancelExchangeApi = (params: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/fx/cancel`, params);
    return Boolean(data);
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
    return false;
  } finally {
    dispatch(isSpinAC(false));
  }
};

const cancelTransactionApi = (params: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/cancel`, params);
    return Boolean(data);
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
    return false;
  } finally {
    dispatch(isSpinAC(false));
  }
};

export {
  cancelTransactionApi,
  cleanOrdersApi,
  electricTransactionApproveApi,
  electricTransactionVerifyApi,
  getTransactionListApi,
  transactionVerifyApi,
  transactionVerifyResendCodeApi,
  getAccountOrdersApi,
  dowloadAccountStatementApi,
  orderStatementApi,
  transactionApproveApi,
  transactionMassiveApproveApi,
  proceedExchangeApi,
  cancelExchangeApi,
  dowloadAccountStatementToPrintApi,
};
